import redactor from './redaction';
let instance = null;
/**
 * Provide logger with your app's environment specific Sentry client instance. This instance will be
 * used to log errors to Sentry.
 * @param sentryInstance
 */
export const setSentryClient = (sentryInstance) => {
    instance = sentryInstance;
};
/**
 * Redact any error, string, or object that is passed and return a string message. If an error is passed, return its
 * redacted error message. This message will be concatenated with other messages and logged to Sentry.
 */
export const redactAndStringify = (message) => {
    if (typeof message === 'string') {
        return redactor.apply(message);
    }
    if (message instanceof Error) {
        return redactor.apply(message.message);
    }
    return JSON.stringify(redactor.apply(message));
};
/**
 * Folks may call logger.error with strings, objects, and / or error objects:
 * `logger.error('something went wrong', {data: 'description'}, err)`.
 *
 * If Sentry is initialized for your app, this will call Sentry.captureException with the first error that is given
 * or with the concatenated messages if no error is given. If more than one error is passed,
 * any additional errors will lose their stacktrace data, but will retain their messages as described below.
 *
 * If the logger has a loggerName, then the log, which will also be the updated error message if an error was passed,
 * will display the concatenated messages together in this order:
 * '[<loggerName>], <descriptive strings, stringified objects, or additional error messages>, err.message',
 * with the logger name always being first and the error message always being last.
 */
export const logToSentry = (messages) => {
    if (instance) {
        if (messages.length === 0) {
            instance.captureException('logToSentry was called with no arguments');
        }
        else {
            const objError = messages.find((m) => m instanceof Error);
            if (objError) {
                const formattedErrorMessage = redactAndStringify(objError);
                const otherMessages = messages.filter((m) => m !== objError);
                const formattedOtherMessages = otherMessages.map(redactAndStringify);
                objError.message = [
                    ...formattedOtherMessages,
                    formattedErrorMessage,
                ].join(', ');
                instance.captureException(objError);
            }
            else {
                const formattedNonErrorMessages = messages.map(redactAndStringify);
                instance.captureException(formattedNonErrorMessages.join(', '));
            }
        }
    }
};
